// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/auth","layout":false,"id":"1"},"2":{"name":"登录","path":"/auth/login","parentId":"1","id":"2"},"3":{"name":"授权回调","path":"/auth/callback","parentId":"1","id":"3"},"4":{"path":"","name":"首页","exact":true,"parentId":"5","id":"4","originPath":"/home"},"5":{"path":"/home","isWrapper":true,"parentId":"ant-design-pro-layout","id":"5"},"6":{"path":"","name":"演练场","exact":true,"parentId":"7","id":"6","originPath":"/playground"},"7":{"path":"/playground","isWrapper":true,"parentId":"ant-design-pro-layout","id":"7"},"8":{"path":"/","redirect":"/home","parentId":"ant-design-pro-layout","id":"8"},"9":{"path":"*","layout":false,"id":"9"},"ant-design-pro-layout":{"id":"ant-design-pro-layout","path":"/","isLayout":true}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import('./EmptyRoute')),
'2': React.lazy(() => import(/* webpackChunkName: "p__Auth__Login__auth" */'@/pages/Auth/Login/auth.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__Auth__Callback__index" */'@/pages/Auth/Callback/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__Home__index" */'@/pages/Home/index.tsx')),
'5': React.lazy(() => import(/* webpackChunkName: "wrappers__container" */'@/wrappers/container.tsx')),
'6': React.lazy(() => import(/* webpackChunkName: "p__Playground__demo" */'@/pages/Playground/demo.tsx')),
'7': React.lazy(() => import(/* webpackChunkName: "wrappers__container" */'@/wrappers/container.tsx')),
'8': React.lazy(() => import('./EmptyRoute')),
'9': React.lazy(() => import(/* webpackChunkName: "p__404" */'@/pages/404.tsx')),
'ant-design-pro-layout': React.lazy(() => import(/* webpackChunkName: "t__plugin-layout__Layout" */'C:/MyWork/new_work/chatbi-frontend/src/.umi-production/plugin-layout/Layout.tsx')),
},
  };
}
